import { Button, HorizontalSpacer, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommLandmarkTools extends Layout {
    buttonAddLandmark: Button;
    buttonCancelLandmark: Button;
    buttonSaveLandmark: Button;
    horizontalspacer4: HorizontalSpacer;
    panelMobileCommLandmark: Panel;
    textboxDescr: Textbox;
    textboxFindnearVendor: Textbox;
    textboxLatitude: Textbox;
    textboxLongitude: Textbox;
    textboxName: Textbox;
}
